var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDnaStrand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M164.12,98.55c10.43-12.38,24-18,42.22-17.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.2,84.22s34.36-7.47,56.59,36.42c0,0,23.28,41.3,64.16,21,0,0,12.6-7.58,18.56-19.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.27,135.58S35,139.67,52.5,120.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M59.46,106.63s18-44.31,62.77-32.64c0,0,17.28,4.12,27.31,24.24,0,0,17.72,40.05,55.11,39.1"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 21.67,
    y1: 120.26,
    x2: 21.67,
    y2: 97.85
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 194.21,
    y1: 120.26,
    x2: 194.21,
    y2: 97.85
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 108.91,
    y1: 131.44,
    x2: 108.91,
    y2: 86.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 36.67,
    y1: 116.05,
    x2: 36.67,
    y2: 103.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 90.39,
    y1: 123,
    x2: 90.39,
    y2: 95.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 126.69,
    y1: 123,
    x2: 126.69,
    y2: 95.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 178.93,
    y1: 116.05,
    x2: 178.93,
    y2: 103.55
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDnaStrand);
export default __webpack_public_path__ + "static/media/DNA_STRAND.230cacded1607d05b0d0ba92875c7779.svg";
export { ForwardRef as ReactComponent };